import { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import { PlayFill, PauseFill, SkipStartFill, SkipEndFill, VolumeUpFill } from 'react-bootstrap-icons';
import playerService from './Service/playerService';
import '../Css/MusicPlayer.css';

export const _2801 = () => {
  const [state, setState] = useState(playerService.getState());

  useEffect(() => {
    playerService.setUpdateCallback(setState);
    return () => playerService.setUpdateCallback(null);
  }, []);

  const handlePlayPause = () => playerService.toggle();
  const handleNext = () => playerService.next();
  const handlePrev = () => playerService.prev();
  const handleSeek = (e) => playerService.seek(Number(e.target.value));
  const handleVolume = (e) => playerService.setVolume(Number(e.target.value));

  const formatTime = (time) => {
    if (!isFinite(time)) return '0:00';
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  };

  return (
    <div className="music-player">
      <Container>
        <div className="player-container">
          <div className="player-header">
            <h2>Music</h2>
          </div>
          <div className="song-info">
            <h3>{state.song.title}</h3>
            <p>{state.song.artist}</p>
          </div>
          <div className="progress-container">
            <input
              type="range"
              min="0"
              max={state.duration || 0}
              value={state.currentTime}
              onChange={handleSeek}
              className="progress-bar"
            />
            <div className="time-info">
              <span>{formatTime(state.currentTime)}</span>
              <span>{formatTime(state.duration)}</span>
            </div>
          </div>
          <div className="controls">
            <button onClick={handlePrev} className="control-btn">
              <SkipStartFill size={24} />
            </button>
            <button onClick={handlePlayPause} className="control-btn play-btn">
              {state.isPlaying ? <PauseFill size={32} /> : <PlayFill size={32} />}
            </button>
            <button onClick={handleNext} className="control-btn">
              <SkipEndFill size={24} />
            </button>
          </div>
          <div className="volume-control">
            <VolumeUpFill size={20} />
            <input
              type="range"
              min="0"
              max="1"
              step="0.01"
              value={state.volume}
              onChange={handleVolume}
              className="volume-slider"
            />
          </div>
        </div>
      </Container>
    </div>
  );
}; 